import {lazy} from 'react';

export const JobDetailLazy = lazy(() => import(/* webpackChunkName: "jobDetail" */ './'));
